import { Injectable } from '@angular/core';

import { Customer } from '@models';
import { CustomerResponseDTO } from '@paymash/sdk/dto/response';
import { CustomerRequestDTO } from '@paymash/sdk/dto/request';

@Injectable({
  providedIn: 'root',
})
export class CustomerMapper {
  public mapToEntity(dto: CustomerResponseDTO): Customer {
    return {
      firstName: dto.firstName,
      lastName: dto.lastName,
      email: dto.email,
      phone: dto.phone,
      salutation: dto.salutation,
    };
  }

  public mapToDTO(entity: Customer): CustomerRequestDTO {
    return {
      firstName: entity.firstName,
      lastName: entity.lastName,
      email: entity.email,
      phone: entity.phone,
      salutation: entity.salutation,
    };
  }
}
